import { GetOtherCandidaciesResponse, PastApplicationAnswers } from "@/types";

export const pastApplications = {
  // The talent's other candidacies that carry screening Q&A, newest
  // application first. Shared by every surface that shows the past-apps pill.
  fromOtherCandidacies: (
    otherCandidacies: GetOtherCandidaciesResponse[] | undefined,
  ): PastApplicationAnswers[] => {
    return (otherCandidacies ?? [])
      .filter((candidacy) => (candidacy.screeningAnswers ?? []).length > 0)
      .map((candidacy) => ({
        candidacyId: candidacy.id,
        companyName: candidacy.company.name,
        createdAt: candidacy.createdAt,
        jobTitle: candidacy.job.title,
        screeningAnswers: candidacy.screeningAnswers ?? [],
      }))
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  },
};
